var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"title"},[_vm._v("提现管理")])]),_c('el-row',[_c('withdraw-card')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }